// Shared so the worker, cacheBusterUtils and the e2e spec cannot drift apart.
export const ARCGIS_TILE_CACHE = 'arcgis-basemap-tiles';
export const ARCGIS_STYLE_CACHE = 'arcgis-basemap-style';
export const ARCGIS_ASSET_CACHE = 'arcgis-basemap-assets';

export const ARCGIS_BASEMAP_CACHES = [
  ARCGIS_TILE_CACHE,
  ARCGIS_STYLE_CACHE,
  ARCGIS_ASSET_CACHE,
] as const;
